<template>
  <Section class="mt-2">
    <logo-and-address />
    <StatementHeader class="mt-4" :statement="currentInvoice" />
      
    <StatementItems class="mt-6" :statement_items="currentInvoice.sales" />

    <v-divider />

    <StatementFooter class="mt-2 mb-2" :invoice="currentInvoice" />

    <v-divider />

    <div class="text-center mt-4" style="font-size: 12px">
      <em>Thank you for using PartnerLists!</em>
    </div>
    
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import LogoAndAddress from './LogoAndAddress'
import StatementHeader from './StatementHeader'
import StatementItems from './StatementItems'
import StatementFooter from './StatementFooter'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StatementDetailView',

  props: {
    invoice_id: {
      type: [Number, String],
      required: true,
    },
  },

  components: { LogoAndAddress, StatementHeader, StatementItems, StatementFooter, Section },

  computed: {
    ...mapGetters('billing', ['currentInvoice']),
  },

  methods: {
    ...mapActions('billing', ['loadCurrentInvoice']),
  },

  created() {
    this.loadCurrentInvoice({ invoice_id: this.invoice_id })
  },
}
</script>